const axios = require('axios');

(() => {
  const checkCampingOption = '.check-customer-camping-check-option'
  const campingOptionClose = '.camping-option-close';
  const campingOptionOpen = '.camping-option-open';
  const campingOptionInfo = '.camping-option-info';

  const init = () => {
    if (location.href.indexOf('customer/camping/check_option') < 1) return

    $('body')
      .on('change', checkCampingOption, changePrice)
  }

  const changePrice = () => {
    const token = $('meta[name="csrf-token"]').attr('content');
    axios({
      url: process.env.JS_BASE_URL + 'customer/camping/check_option/change',
      method: 'POST',
      data: $('form').serialize(),
      withCredentials: true,
      headers: { 'X-CSRF-Token': token }
    })
      .then(response => {
        $('.plan-block-right').html(response['data'])
        showOptionInfoContent();
      })
      .catch(error => {
        console.log(error);
        return error;
      })
  }

  const showOptionInfoContent = e => {
    $(campingOptionClose).fadeIn();
    $(campingOptionInfo).fadeIn();
    $(campingOptionOpen).fadeOut();
  }

  $(init);
})();